"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandedPackagingClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const SERVICE_URL = process.env.BRANDED_PACKAGING_SERVICE_URL;
const BASIC_AUTH_USER = process.env.BRANDED_PACKAGING_BASIC_AUTH_USER;
const BASIC_AUTH_PASSWORD = process.env.BRANDED_PACKAGING_BASIC_AUTH_PASSWORD;
class BrandedPackagingClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: SERVICE_URL,
        basicAuthUser: BASIC_AUTH_USER,
        basicAuthPassword: BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!BASIC_AUTH_USER || !BASIC_AUTH_PASSWORD) {
            commons_logs_1.log.warn("BRANDED_PACKAGING_BASIC_AUTH_USER or BRANDED_PACKAGING_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getBrandedPackageRecommendations(request) {
        const encodedRequest = encodeURIComponent(JSON.stringify(request));
        return this.get(`/brandedPackage/packageRecommendations`, {
            request: encodedRequest,
        });
    }
    async getBrandedMaterialRecommendations(request) {
        const encodedRequest = encodeURIComponent(JSON.stringify(request));
        return this.get(`/brandedPackage/materialRecommendations`, {
            request: encodedRequest,
        });
    }
    async getBrandedPackagingEnabledSellers() {
        return this.get("/brandedPackage/sellers");
    }
    async getBrandedPackagingDisabledDskus() {
        return this.get("/brandedPackage/dskus");
    }
    async getIsBrandedPackagingEnabled(dskus) {
        return this.post("/brandedPackage/getIsBrandedPackagingEnabled", {
            dskus,
        });
    }
    async createShipmentPackingSlip(request) {
        return this.post("/shipmentPackage/packingSlip", { packingSlipData: request });
    }
    async convertPDFToZpl(request) {
        return this.post("/brandedPackage/convertPDFToZpl", request);
    }
}
exports.BrandedPackagingClient = BrandedPackagingClient;
//# sourceMappingURL=BrandedPackagingClient.js.map